import React from "react";
import { useParams, Link } from "react-router-dom";
import "./BatteryDetail.css";

const batteryData = {
  "inverter-batteries": {
    categoryLabel: "Inverter Batteries",
    ot1500: {
      title: "OT-1500",
      subtitle: "Tall Tubular Inverter Battery",
      capacity: "150Ah",
      modelNo: "OT1500",
      volt: "12V",
      dimensions: "410 × 176 × 233 mm",
      warranty: "36 Months (24 + 12)*",
      image: "/ot1500.jpg",
      details:
        "Compact and efficient power backup for small homes and offices. Engineered with advanced tubular plate technology for a long service life of up to 5 years — even through daily power cuts.",
      features: ["Deep cycle performance", "Low water loss", "Quick recharge", "Maintenance-friendly"],
    },
    ot1800: {
      title: "OT-1800",
      subtitle: "Tall Tubular Inverter Battery",
      capacity: "180Ah",
      modelNo: "OT1800",
      volt: "12V",
      dimensions: "502 × 191 × 255 mm",
      warranty: "36 Months (24 + 12)*",
      image: "/ot1800.jpg",
      details:
        "Balanced capacity for medium households. Features quick recharge and robust build quality to handle the demanding power requirements of modern homes across Bihar.",
      features: ["Robust tubular plates", "Fast recharge cycle", "High charge acceptance", "Extended backup"],
    },
    ot2000: {
      title: "OT-2000",
      subtitle: "Tall Tubular Inverter Battery",
      capacity: "220Ah",
      modelNo: "OT2000",
      volt: "12V",
      dimensions: "520 × 200 × 270 mm",
      warranty: "36 Months (24 + 12)*",
      image: "/ot2000.jpg",
      details:
        "High-capacity battery for extended backup. Perfect for heavy appliances and commercial setups that cannot afford downtime. Advanced grid alloy ensures minimal corrosion.",
      features: ["High capacity storage", "Anti-corrosion grid", "Suitable for heavy load", "Consistent output"],
    },
    os120: {
      title: "OS-120",
      subtitle: "Jumbo Tubular Inverter Battery",
      capacity: "120Ah",
      modelNo: "OS120",
      volt: "12V",
      dimensions: "525 × 220 × 290 mm",
      warranty: "24 Months",
      image: "/os120.jpg",
      details:
        "Maximum power for large setups and commercial establishments. Offers superior longevity and consistent performance even under heavy continuous load.",
      features: ["Jumbo tubular design", "Superior cycle life", "Heavy-duty terminal", "Low self-discharge"],
    },
    os150: {
      title: "OS-150",
      subtitle: "Jumbo Tubular Inverter Battery",
      capacity: "150Ah",
      modelNo: "OS150",
      volt: "12V",
      dimensions: "525 × 220 × 290 mm",
      warranty: "36 Months (24 + 12)*",
      image: "/os150.jpg",
      details:
        "Heavy-duty jumbo tubular battery engineered for commercial power demands. Delivers reliable backup through thousands of charge-discharge cycles.",
      features: ["Jumbo tubular design", "Superior cycle life", "Heavy-duty terminal", "Low self-discharge"],
    },
    os200: {
      title: "OS-200",
      subtitle: "Jumbo Tubular Inverter Battery",
      capacity: "200Ah",
      modelNo: "OS200",
      volt: "12V",
      dimensions: "525 × 220 × 290 mm",
      warranty: "36 Months (24 + 12)*",
      image: "/os200.jpg",
      details:
        "Top-tier capacity for critical power requirements and large commercial installations. The highest-performing battery in the Oster inverter range.",
      features: ["Maximum backup power", "Industrial grade build", "Spill-proof design", "Wide temperature range"],
    },
  },
  "e-rickshaw-batteries": {
    categoryLabel: "E-Rickshaw Batteries",
    "120ah": {
      title: "ER-120",
      subtitle: "E-Rickshaw Flat Battery",
      capacity: "120Ah",
      modelNo: "OS 120 FLAT",
      volt: "12V",
      dimensions: "260 × 173 × 214 mm",
      warranty: "6 Months",
      image: null,
      details:
        "Lightweight and compact design built for e-rickshaws on Indian urban roads. Ensures smooth rides, quick charging, and reliable daily performance.",
      features: ["Lightweight build", "Fast charge recovery", "Vibration resistant", "High discharge rate"],
    },
    "130ah": {
      title: "ER-130",
      subtitle: "E-Rickshaw Tubular Battery",
      capacity: "130Ah",
      modelNo: "OS 130 TUBULAR",
      volt: "12V",
      dimensions: "260 × 173 × 214 mm",
      warranty: "9 Months",
      image: null,
      details:
        "Extended range with enhanced durability. Ideal for routes with frequent stops and varying load conditions in urban and semi-urban environments.",
      features: ["Extended range", "Tubular plate design", "Urban road tested", "Long service life"],
    },
    "140ah": {
      title: "ER-140",
      subtitle: "E-Rickshaw Tubular Battery",
      capacity: "140Ah",
      modelNo: "OS 140 TUBULAR",
      volt: "12V",
      dimensions: "260 × 173 × 214 mm",
      warranty: "12 Months",
      image: null,
      details:
        "Optimal performance balancing power and efficiency. The best choice for heavy-load e-rickshaws running long daily routes.",
      features: ["Max payload support", "Superior energy density", "High cycle count", "Heat resistant"],
    },
  },
  "solar-batteries": {
    categoryLabel: "Solar Batteries",
    "80ah": {
      title: "SB-80",
      subtitle: "Solar Deep Cycle Battery",
      capacity: "80Ah",
      modelNo: "SB80",
      volt: "12V",
      dimensions: "305 × 170 × 210 mm",
      warranty: "24 Months",
      image: null,
      details:
        "Entry-level solar battery ideal for small off-grid systems and home solar setups. Reliable deep cycle storage with consistent charge retention.",
      features: ["Deep cycle rated", "Low self-discharge", "Solar charge optimised", "Maintenance-free option"],
    },
    "100ah": {
      title: "SB-100",
      subtitle: "Solar Deep Cycle Battery",
      capacity: "100Ah",
      modelNo: "SB100",
      volt: "12V",
      dimensions: "410 × 176 × 233 mm",
      warranty: "36 Months",
      image: null,
      details:
        "Consistent energy supply for moderate residential solar setups. Handles partial state of charge (PSoC) operation common in solar applications.",
      features: ["PSoC tolerant", "High charge efficiency", "Residential grade", "Robust separator"],
    },
    "150ah": {
      title: "SB-150",
      subtitle: "Solar Deep Cycle Battery",
      capacity: "150Ah",
      modelNo: "SB150",
      volt: "12V",
      dimensions: "502 × 191 × 255 mm",
      warranty: "48 Months",
      image: null,
      details:
        "Mid-tier capacity for larger solar arrays. Enhanced cycle life for daily deep discharges typical in solar storage applications.",
      features: ["Enhanced cycle life", "Commercial solar ready", "Deep discharge recovery", "Grid-tie compatible"],
    },
    "200ah": {
      title: "SB-200",
      subtitle: "Solar Deep Cycle Battery",
      capacity: "200Ah",
      modelNo: "SB200",
      volt: "12V",
      dimensions: "520 × 200 × 270 mm",
      warranty: "60 Months",
      image: null,
      details:
        "High-efficiency storage for maximum solar performance. Designed for large commercial installations where reliability is non-negotiable.",
      features: ["Maximum storage", "5-year warranty", "Industrial grade", "High efficiency cells"],
    },
  },
  "tractor-batteries": {
    categoryLabel: "Tractor Batteries",
    "88ah": {
      title: "TB-88",
      subtitle: "Tractor Starting Battery",
      capacity: "88Ah",
      modelNo: "TB88",
      volt: "12V",
      dimensions: "353 × 175 × 190 mm",
      warranty: "24 Months",
      image: null,
      details:
        "Compact and dependable starting battery for light-duty tractors. Delivers reliable cold-cranking power even in early morning conditions.",
      features: ["High CCA rating", "Vibration resistant", "Compact form factor", "Reliable cold start"],
    },
    "100ah": {
      title: "TB-100",
      subtitle: "Tractor Starting Battery",
      capacity: "100Ah",
      modelNo: "TB100",
      volt: "12V",
      dimensions: "410 × 176 × 233 mm",
      warranty: "36 Months",
      image: null,
      details:
        "Standard power for medium-duty tractors in rugged field conditions. Built to withstand the vibration and shock of agricultural terrain.",
      features: ["Shock resistant build", "All-terrain tested", "Sustained cranking", "Long standby life"],
    },
    "120ah": {
      title: "TB-120",
      subtitle: "Heavy-Duty Tractor Battery",
      capacity: "120Ah",
      modelNo: "TB120",
      volt: "12V",
      dimensions: "502 × 191 × 255 mm",
      warranty: "48 Months",
      image: null,
      details:
        "Heavy-duty battery with excellent cold-cranking amps for larger agricultural machinery. Handles the demands of commercial farming operations.",
      features: ["Excellent CCA", "Heavy machinery rated", "Commercial farm grade", "Corrosion-proof terminals"],
    },
    "150ah": {
      title: "TB-150",
      subtitle: "Heavy-Duty Tractor Battery",
      capacity: "150Ah",
      modelNo: "TB150",
      volt: "12V",
      dimensions: "520 × 200 × 270 mm",
      warranty: "60 Months",
      image: null,
      details:
        "Maximum durability for the toughest agricultural conditions. The top performer in the Oster tractor range, trusted by large-scale farmers across North India.",
      features: ["Maximum CCA", "5-year warranty", "Extreme duty rated", "Field proven reliability"],
    },
  },
  "automotive-batteries": {
    categoryLabel: "Automotive Batteries",
    "35ah": {
      title: "AB-35",
      subtitle: "Automotive Starting Battery",
      capacity: "35Ah",
      modelNo: "AB35",
      volt: "12V",
      dimensions: "197 × 129 × 227 mm",
      warranty: "24 Months",
      image: null,
      details:
        "Compact and lightweight battery engineered for small cars and hatchbacks. Ensures reliable starts every time with minimal maintenance.",
      features: ["Compact design", "Quick start", "Spill-proof", "Maintenance-friendly"],
    },
    "65ah": {
      title: "AB-65",
      subtitle: "Automotive Starting Battery",
      capacity: "65Ah",
      modelNo: "AB65",
      volt: "12V",
      dimensions: "278 × 175 × 190 mm",
      warranty: "36 Months",
      image: null,
      details:
        "Dependable mid-size battery for sedans and SUVs. Steady power delivery for modern vehicles with multiple electronic systems.",
      features: ["Wide vehicle compatibility", "High reserve capacity", "Steady voltage output", "Corrosion resistant"],
    },
    "90ah": {
      title: "AB-90",
      subtitle: "Automotive Starting Battery",
      capacity: "90Ah",
      modelNo: "AB90",
      volt: "12V",
      dimensions: "353 × 175 × 190 mm",
      warranty: "48 Months",
      image: null,
      details:
        "Truck-ready battery with enhanced durability and high cranking power. Built for commercial vans, trucks, and larger SUVs on Indian highways.",
      features: ["High cranking power", "Truck rated", "Durable construction", "Highway proven"],
    },
    "120ah": {
      title: "AB-120",
      subtitle: "Heavy-Duty Automotive Battery",
      capacity: "120Ah",
      modelNo: "AB120",
      volt: "12V",
      dimensions: "502 × 191 × 255 mm",
      warranty: "60 Months",
      image: null,
      details:
        "Maximum power for heavy-duty vehicles, fleet trucks, and commercial transport. The highest-capacity battery in the Oster automotive range.",
      features: ["Fleet grade reliability", "Maximum cold cranking", "5-year warranty", "Heavy vehicle rated"],
    },
  },
};

function BatteryPlaceholder({ title }) {
  return (
    <div className="detail-placeholder">
      <svg viewBox="0 0 120 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="detail-placeholder-icon">
        <rect x="3" y="12" width="108" height="48" rx="5" stroke="#f91919" strokeWidth="3" />
        <rect x="111" y="24" width="9" height="24" rx="2.5" fill="#f91919" opacity="0.4" />
        <rect x="14" y="22" width="30" height="28" rx="3" fill="#f91919" opacity="0.2" />
        <rect x="50" y="22" width="30" height="28" rx="3" fill="#f91919" opacity="0.12" />
        <rect x="86" y="22" width="16" height="28" rx="3" fill="#f91919" opacity="0.08" />
      </svg>
      <span className="detail-placeholder-label">{title}</span>
    </div>
  );
}

function BatteryDetail() {
  const { categoryName, batteryId } = useParams();

  const categoryData = batteryData[categoryName] || {};
  const { categoryLabel = "Products", ...batteries } = categoryData;
  const battery = batteries[batteryId];

  const notFound = !battery;
  const b = battery || {
    title: "Not Found",
    subtitle: "",
    capacity: "—",
    modelNo: "—",
    volt: "—",
    dimensions: "—",
    warranty: "—",
    image: null,
    details: "This battery could not be found.",
    features: [],
  };

  const specs = [
    { label: "Model No.", value: b.modelNo },
    { label: "Voltage", value: b.volt },
    { label: "Capacity (C20 @ 27°C)", value: b.capacity },
    { label: "Dimensions (L × W × H)", value: b.dimensions },
    { label: "Warranty", value: b.warranty },
  ];

  return (
    <div className="battery-detail-page">

      {/* ── Hero / Breadcrumb bar ── */}
      <section className="detail-hero">
        <div className="detail-hero-inner">
          <nav className="detail-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="detail-bc-link">Home</Link>
            <span className="detail-bc-sep">›</span>
            <Link to="/#products" className="detail-bc-link">Products</Link>
            <span className="detail-bc-sep">›</span>
            <Link to={`/category/${categoryName}`} className="detail-bc-link">{categoryLabel}</Link>
            <span className="detail-bc-sep">›</span>
            <span className="detail-bc-current">{b.title}</span>
          </nav>
        </div>
      </section>

      {/* ── Main content ── */}
      <section className="detail-body">
        <div className="detail-container">

          {/* Left: image */}
          <div className="detail-image-col">
            <div className="detail-image-wrap">
              {b.image ? (
                <img src={b.image} alt={b.title} className="detail-image" />
              ) : (
                <BatteryPlaceholder title={b.title} />
              )}
            </div>
            {!notFound && (
              <a href="/#contact" className="detail-enquire-btn">
                Enquire Now
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{marginLeft:8}}>
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            )}
          </div>

          {/* Right: info */}
          <div className="detail-info-col">
            <p className="detail-eyebrow">{b.subtitle}</p>
            <h1 className="detail-title">{b.title}</h1>
            <p className="detail-description">{b.details}</p>

            {b.features && b.features.length > 0 && (
              <ul className="detail-features">
                {b.features.map((f) => (
                  <li key={f} className="detail-feature-item">
                    <span className="feature-dot" />
                    {f}
                  </li>
                ))}
              </ul>
            )}

            {/* Spec table */}
            <div className="spec-table">
              <h3 className="spec-table-heading">Specifications</h3>
              {specs.map(({ label, value }) => (
                <div key={label} className="spec-row">
                  <span className="spec-label">{label}</span>
                  <span className="spec-value">{value}</span>
                </div>
              ))}
              <p className="spec-footnote">* Warranty terms as per warranty card issued at time of purchase.</p>
            </div>

          </div>

        </div>

        {/* Back link */}
        <div className="detail-back-row">
          <Link to={`/category/${categoryName}`} className="detail-back-link">
            ← Back to {categoryLabel}
          </Link>
        </div>
      </section>

    </div>
  );
}

export default BatteryDetail;
